













import { Vue, Component } from "@/shared/vuepack";

@Component({})
export default class PasswordRequirements extends Vue {}
